import { Injectable } from '@angular/core';

/**
 * Estado efímero del flujo de checkout para navegación final.
 *
 * Objetivo:
 * - Permitir acceso a páginas finales (`pago-exitoso`, `pago-rechazado`, `pago-error`)
 *   solo cuando la navegación viene del proceso de pago.
 * - Evitar accesos directos por URL a resultados sin haber pasado por checkout.
 */
@Injectable({
  providedIn: 'root'
})
export class PaymentFlowStateService {
  private finalPageAllowed = false;

  /**
   * Habilita un único ingreso a páginas finales.
   */
  allowFinalPage(): void {
    this.finalPageAllowed = true;
  }

  /**
   * Consume la autorización para navegación final.
   *
   * Retorna `true` solo una vez después de `allowFinalPage()`.
   */
  consumeFinalPageAccess(): boolean {
    if (!this.finalPageAllowed) {
      return false;
    }

    this.finalPageAllowed = false;
    return true;
  }
}
